<script>
import AdminLayout from '@layouts/admin-main'
import PublicBalanceTransferList from '@components/admin/public-balance-transfer-list'

export default {
  page: {
    title: 'PublicBalanceTransferList',
    meta: [{ name: 'description', content: 'PublicBalanceTransferList' }],
  },
  components: { AdminLayout, PublicBalanceTransferList },
}
</script>

<template>
  <AdminLayout>
    <PublicBalanceTransferList />
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
